import React from 'react';
import DsLabel from './index';

const LabelSucceed = ({ children }) => (
        <DsLabel icon="check" className="text-base" iconClassName="text-xl text-status-green">
          {children}
        </DsLabel>
);

export default LabelSucceed;
